import { useState, useEffect } from 'react';
import { base44 } from '@/api/base44Client';
import { useSession } from '@/lib/SessionContext';
import { toast } from 'sonner';

// TODO: Ganti dengan VAPID Public Key yang asli dari server backend nanti
const PUBLIC_VAPID_KEY = 'BEl62iUYgUivxIkv69yViEuiBIa-Ib9-SkvMeAtA3LFgDzkrxZJjSgSnfckjBJuB232d-O7uWLw2mBtdV1B1kQ8';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function usePushNotification() {
  const { member } = useSession();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isSupported, setIsSupported] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      setIsSupported(true);
      checkSubscription();
    }
  }, []);

  const checkSubscription = async () => {
    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();
      setIsSubscribed(!!subscription);
    } catch (err) {
      console.error('Error checking push subscription:', err);
    }
  };

  const subscribeToPush = async () => {
    if (!member) {
      toast.error('Harap login terlebih dahulu');
      return;
    }

    setIsLoading(true);
    try {
      // Minta izin ke user
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        throw new Error('Izin notifikasi tidak diberikan oleh sistem/user.');
      }

      const registration = await navigator.serviceWorker.ready;
      
      // Subscribe via PushManager browser
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
      });

      // Simpan subscription token ke database member
      // Disini kita simpan JSON string dari subscription ke record member
      // Catatan: Karena 'push_subscription' mungkin belum ada kolomnya di DB, 
      // pastikan schema tabel team_members diperbarui. 
      await base44.entities.TeamMember.update(member.id, {
        // Kita sementara masukkan ke notes atau tambahkan custom field push_subscription. 
        // Mengingat saya tidak tahu struktur table sepenuhnya, saya akan panggil update dengan push_subscription.
        push_subscription: JSON.stringify(subscription)
      });

      setIsSubscribed(true);
      toast.success('Notifikasi HP Berhasil Diaktifkan! 🎉');
      
    } catch (err) {
      console.error('Gagal mengaktifkan notifikasi:', err);
      toast.error(err.message || 'Gagal mengaktifkan notifikasi PWA');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isSupported,
    isSubscribed,
    isLoading,
    subscribeToPush
  };
}
